import { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, Upload, X, ArrowLeft, ArrowRight, Loader2, AlertTriangle, GripVertical, ChevronLeft, ChevronRight, Star } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { useGoogleMaps } from '../hooks/useGoogleMaps';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CATEGORIES = [
  { slug: 'ultraleggeri', name: 'Ultraleggeri' },
  { slug: 'propulsione-singola', name: 'Propulsione Singola' },
  { slug: 'propulsione-multipla', name: 'Propulsione Multipla' },
  { slug: 'turboelica', name: 'Turboelica' },
  { slug: 'jet', name: 'Jet' },
  { slug: 'elicotteri', name: 'Elicotteri' },
];

const ALL_MANUFACTURERS = [
  'Acro Sport Inc','Adventurer','Aermacchi Lockheed','Aero AT','Aero Commander','Aero Designs',
  'Aeroalcool','Aerocomp Inc','Aerodrome','Aeromot','Aeronca','Aeroprakt Ltd','Aeropro',
  'Aeroprogress','Aerospatiale','Aerospool','Aerosport','Aerostar','Aerotechnik',
  'Air Command','Air Creation','Air Tractor','Aircoupe','Aircraft Technologies Inc','Airmax',
  'Akrotech','Alpi Aviation','Ambrosini','Amd','American Champion','American Legend',
  'Anderson, Greenwood & Co','ANG Patriot UA','Antonov','Apex','Apollo Fox','Applebay Aviation',
  'Aquila','Arnet Pereyra','Arv','Asap','Asso','Atec','Auster','Avama','Aviamilano',
  'Aviastroitel','Aviat','Aviatika','Aviation Norman Dube','Avid','Avions/Mudry',
  'Baken','Bakeng Duece','Barney Oldfield Aircraft Company','Beaver','Bede','Beechcraft',
  'Bell','Bellanca','Benton','Beriev','Bettsm','Blackshape','Boeing','Boeing/Stearman',
  'Boisavia','Bolkow','Boothby','Bowers','Bradley','Breezer','Breezy','Bristol',
  'British Aerospace','BRM Aero / Bristell','Brooklands Aerospace','Brush Master','Buccaneer',
  'Bucker Jungmann','Bucker Jungmeister','Buethe Enterprises','Burchinal',
  'Callair','Calvin Parker','Canadair','Canadian Car & Foundry','Canadian Home Rotors, Inc',
  'Canso','Capella','Caproni','Casbon','Cassutt','Celebrity','Cessna','CFM Aircraft','Cgs',
  'CH-7','Champion','Chance Vought','Chris Tena','Christavia','Christen','Cirrus','Cmelak',
  'Co-Z Development Corp','Col Air','Columbia','Comco Ikarus','Command-Aire','Commander',
  'Commonwealth','Commonwealth Aircraft Corp','Composite Jet','Consolidated',
  'Consolidated Vultee','Convair','Coot','Corben','Corby','Corsair','Corvus','Cubcrafters','Culver',
  'Curtiss','Curtiss-Wright','Czech Aircraft Works',
  'D Apuzzo','Damler','Davis Aircraft Corp','Dehavilland','Denemark Eric G','Diamond','Dimona',
  'Direct Fly','Douglas','Dova','Dream Aircraft','Dynaero',
  'Eaa Biplane','Eads/PZL','Eads/Socata','Eagle','Eagle R&D','Eaglerock','Earthstar','EDI',
  'Edmunds','Ekolot','Embraer','Ercoupe','Ercoupe/Alon','Ercoupe/Forney','Euro-ALA','Europa',
  'Evans','Evektor','Explorer Aviation','Express','EXTRA Aircraft',
  'Fairchild','Fairey','Falcon','Falconar','Fantasy Air','Farrar Davis','Ffa','Fiat','Fiesler',
  'Fisher','Fleet','Flight Design','Flightstar','Fluzeugbau','Fly Synthesis',
  'Flying K Enterprises','Focke Wulf','Fokker','Forster','Found Aircraft Co','Found Centennial',
  'Fournier','Frison','Fuji','Funk',
  'Garbadini','Gardan','Garner','General','General Avia','Gippsland Aeronautics','Glasair',
  'Globe','Gobosh','Gogetair','Golden Circle Air','Great Lakes','Great Plains','Grega','Grob',
  'Groen Bros','Groppo Aviazione','Grumman','Grumman/American General','Gryf Aircraft',
  'Gut Works','Gyroflug',
  'Habersetzer Gary L','Hamilton','Harmon','Harper-Behr Alyson','Hatz','Hatz/Kelly D','Hawk',
  'Hawker','HB-Flugtechnik','Helio','Hildreth','Hindustan Aeronautics Ltd','Hipps Superbirds',
  'Holmes Milton N','Howard',
  'I.C.P. Aviation','Iar S.a. Brasov','Icarus','Ilyushin','Indus Aviation Inc',
  'Iniziative Industriali','Interavia','Interplane','Interstate','Ipe Aeronaves','Ison',
  'Jabiru','Javelin','Jihlavan','JMB Aircraft','Jodel','Johnny Morris',
  'K & S','K-Meyer','Keleher','Ken Brock','Kingfisher','Kinner','KIS','Kit Fox','Klemm','Kolb',
  'Lake','Lancair','Langhurst','Laser','Legend','Legendary','Let','Lewinski Roman',
  'Leza Lockwood','Liberty Aerospace','Lockheed','Loehle','Lola-Utva','Lucas','Luscombe',
  'Macchi','Marawing','Marcel Jurca','Marquart','Martin (twa)','Maule','Max Holste','MB Avio',
  'MBB','Mcdonnel Douglas','Mcfee E Donald','Mdd','Merlin','Messerschmitt','Meyers','Micco',
  'Microleve','Midget','Midwest Aerosport','Mikoyan','Miles','Mince','Mitchell','Mitchell Wing',
  'Mitsubishi','Mong Sport','Monnett','Monocoupe','Mooney','Morane-Saulnier','Mosler Motors',
  'MSW Aviation','Mudry','Murphy','Mustang Aeronautics','MXP','Mystic',
  'Nanchang','Naval Aircraft','Navion','Navy','Nesmith','New Standard','Nieuport','Noorduyne',
  'Nord','North American','Nuwaco',
  'O.M.M.','Osprey Aircraft',
  'Papa 51 Ltd. Co.','Partenavia','Passenger','Pegasus Aviation','Phillips','Piaggio','Piel',
  'Pietenpol','Pilatus','Piper','Piper-Sterling','Pipistrel','Pitts','Polliwagen','Porterfield',
  'Preceptor','Prescott Aeronautical','Produits Aviatech Inc','Progressive',
  'Progressive Aerodyne','Promecc Aerospace','Protech','Prowler Aviation','Pulsar','Putzer','Pzl',
  'Quad City Ultralight','Questair','Quickie Aircraft Corp.','Quicksilver','Quikkit',
  'Rambo','Rand Robinson','Rans','Rearwin','Reflex Fiberglass Works','Refly','Reggiane','Reims',
  'Remos','Renegade','Repeat','Republic','Revolution','Rhein-Flugzeugbau','Rihn','Riley',
  'Robin','Rocket','Rockwell','Rokospol','Roland Aircraft','Rose','Rotary Air Force','Rotorway',
  'Ruschmeyer','Russell','Rutan','Rutten','Ryan',
  'S.G Aviation','Sa Ravin','Saab','Sabre Aircraft','Saint Louis','Scheibe','Schlepp',
  'Schweizer Glider','Scottish Aviation','Seawind','Senior Aero Sport','Sequoia','Shark Aero',
  'Siai Marchetti','Siat','Sibley Michael D','Silhouette','Skyfly','Slepcev Aircraft Company',
  'Slingsby','Slipstream','Smith','Smyth','Snow','Softex','Soko','Sokol','Sonaca','Sonex',
  'Sopwith','Sorrell Aircraft','Spartan','Speed','Spencer Aircraft','Spezio','Sport Copter',
  'Sportavia','Sports Aviation','Stampe','Star-Lite','Starduster','Staudcher','Steen','Stemme',
  'Stewart','Stinson','Stits','Stol','Stolp','Stout/Ford','Sukhoi','Supermarine','Swearingen',
  'Swift','Symphony Aircraft',
  'Tapanee','Tarragon','Taylor','Taylorcraft','Team Rocket','Team Tango','Technoavia','Tecnam',
  'Temco','Thorp','Tiffen Nord','Tiger Aircraft','Titan','TL-Ultralight','Tomark','Travel Air',
  'Tri-R Technologies','Trojan','Tupolev','Turbine Cubs','Turner',
  'Ultimate','Ultravia Aero','Urbanair','US Light Aircraft Corp',
  'V-Stol','Valentin','Van\'s Aircraft','Vancraft','Varga','Vector','Velocity Aircraft',
  'Vertical Aviation Technologies','Viking','Villeneuve','Vol Mediterrani','Volmer','Vultee',
  'VV-Avia',
  'W-F-W','Waco','Wag Aero','War Aircraft Replicas','Warner Aircraft','Wassmer',
  'Wd Flugzeugleichtbau Gmbh','Weatherly','Weedhopper','Wheeler','Wittman','Woodwind',
  'Woody Pusher','WSK-pzl-Mielec',
  'Xtremeair',
  'Yakovlev',
  'Zenair/Zenith','Zia','Zivko','Zlin','Zmaj',
  'OTHERS'
];

const MULTI_ENGINE_MANUFACTURERS = [
  'Acro Sport Inc','Adam Aircraft','Adventurer','Aermacchi Lookheed','Aero','Aero Commander',
  'Aero Designs','Aerocomp Inc.','Aerodrome','Aeromot','Aeronca','Aeroprakt Ltd','Aeroprogress',
  'Aerospatiale','Aerosport','Aerostar','Air Command','Air Creation','Air Tractor',
  'Aircraft Technologies Inc','Airmax','Akrotech','Alpi Aviation','Ambrosini','American Champion',
  'American General','American Legend','Anderson, Greenwood & Co','ANG Patriot UA','Antonov',
  'Applebay Aviation','Arnet Pereyra','Arv','Asap','Atec','Auster','Aviastroitel','Aviat',
  'Aviatika','Aviation Norman Dube','Avid','Bakeng Duece','Barney Oldifeld Aircraft Company',
  'Beagle','Beaver','Bede','Beechcraft','Bell','Bellanca','Beriev','Bettsm','Boeing',
  'Boeing/Stearman','Bolkow','Boothby','Bowers','Bradley','Breezy','Bristol','British Aerospace',
  'Britten Norman','Brush Master','Buccaneer','Bucker Jungmann','Bucker Jungmeister',
  'Buethe Enterprises','Burchinal','Calvin Parker','Camair','Canadair','Canadian Car & Foundry',
  'Canadian Home Rotors, Inc.','Capella','Caproni','Casbon','Cassutt','Cessna','Cfm Aircraft',
  'Cgs','CH-7','Champion','Chance Vought','Chris Tena','Christavia','Christen','Cmelak',
  'Co-Z Development Corp','Commander','Commonwealth','Commonwealth Aircraft Corp','Composite Jet',
  'Consolidated','Consolidated Vultee','Convair','Coot','Corben','Corby','Corsair','Cubcrafters',
  'Culver','Curtiss','Curtiss-Wright','D Apuzzo','Damler','Davis Aircraft Corp','Dehavilland',
  'Denemark Eric G','Diamond','Dornier','Douglas','Dream Aircraft','Dynaero','Eaa Biplane',
  'Eagle R&D','Eaglerock','Earthstar','EDI','Edmunds','Embraer','Ercoupe','Europa','Evans',
  'Explorer Aviation','Express','Fairchild','Fairey','Falcon','Falconar','Farrar Davis','Fiat',
  'Fiesler','Fisher','Fleet','Flightstar','Flying K Enterprises','Focke Wulf','Fokker','Forster',
  'Found Aircraft Co','Fournier','Frison','Garbadini','Garner','General','Gippsland Aeronautics',
  'Glasair','Golden Circle Air','Great Plains','Grega','Groen Bros','Grumman','Gut Works',
  'Habersetzer Gary L','Hamilton','Harmon','Harper-Behr Alyson','Hatz','Hatz/Kelly D','Hawk',
  'Hawker','HB-Flugtechnik','Helio','Hildreth','Hipps Superbirds','Holmes Milton N','Howard',
  'Iar S.a. Brasov','Ilyushin','Iniziative Industriali','Interavia','Interstate','Ipe Aeronaves',
  'Ison','Jabiru','Javelin','Jodel','Johnny Morris','K & S','K-Meyer','Keleher','Ken Brock',
  'Kingfisher','Kinner','Kit Fox','Klemm','Lake','Lancair','Langhurst','Laser','Legend',
  'Legendary','Let','Lewinski Roman','Leza Lockwood','Lockheed','Loehle','Lola-Utva','Luscombe',
  'Macchi','Marcel Jurca','Maule','Max Holste','MBB','Mcdonnell Douglas','Mcfee e Donald',
  'Merlin','Messerschmitt','Midget','Midwest Aerosport','Mikoyan','Miles','Mince','Mitchell',
  'Mitchell Wing','Mitsubishi','Mong Sport','Monnett','Monocoupe','Morane-Saulnier',
  'Mosler Motors','Murphy','Mustang Aeronautics','Nanchang','Naval Aircraft','Navy','Nesmith',
  'New Standard','Nieuport','Noorduyne','Nord','North American','Nuwaco','Osprey Aircraft',
  'Papa 51 Ltd. Co.','Partenavia/Vulcanair','Passenger','Pegasus Aviation','Phillips','Piaggio',
  'Pietenpol','Pilatus','Piper','Piper-Sterling','Pitts','Polliwagen','Porterfield',
  'Prescott Aeronautical','Produits Aviatech Inc','Progressive','Progressive Aerodyne','Protech',
  'Prowler Aviation','Pulsar','Putzer','Pzl','Quad City Ultralight','Questair',
  'Quickie Aircraft Corp.','Quicksilver','Quikkit','Rand Robinson','Rans','Rearwin',
  'Reflex Fiberglass Works','Refly','Reggiane','Repeat','Republic','Revolution',
  'Rhein-Flugzeugbau','Rihn','Riley','Rockwell','Rose','Rotary Air Force','Russell','Rutan',
  'Rutten','Ryan','S.G Aviation','Sa Ravin','Sabre Aircraft','Saint Louis','Schlepp',
  'Schweizer Glider','Scottish Aviation','Seabird Amphibian','Seawind','Sequoia','Siai Marchetti',
  'Siblay Michael D','Silhouette','Skyfly','Slepcev Aircraft Company','Slipstream','Smith','Smyth',
  'Snow','Socata','Softex','Soko','Sokol','Sonex','Sopwith','Sorrell Aircraft','Spartan','Speed',
  'Spencer Aircraft','Spezio','Sport Copter','Sportavia','Sports Aviation','Stampe','Star-Lite',
  'Staudacher','Steen','Stewart','Stinson','Stits','Stol','Stolp','Stout/Ford','Sukhoi',
  'Supermarine','Swearingen','Swift','Tapanee','Taylor','Taylorcraft','Team Rocket','Team Tango',
  'Technoavia','Tecnam','Temco','Thorp','Titan','TL-Ultralight','Travel Air','Tri-R Technologies',
  'Trojan','Tupolev','Turbine Cubs','Turner','Ultimate','Ultravia Aero','US Light Aircraft Corp',
  'Van\'s Aircraft','Vancraft','Vector','Velocity Aircraft','Vertical Aviation Technologies','Viking',
  'Volmer','Vulcanair','Vultee','Waco','Wag Aero','War Aircraft Replicas','Warner Aircraft',
  'Wd Flugzeugleichtbau Gmbh','Weatherly','Weedhopper','Wheeler','Wing','Wittman','Woodwind',
  'Woody Pusher','Xtremeair','Yakovlev','Zenair/Zenith','Zia','Zivko','Zlin','Zmaj',
  'OTHERS'
];

const TURBOPROP_MANUFACTURERS = [
  'Acro Sport Inc','Aermacchi Lockheed','Aero','Aero Design','Aerocomp Inc.','Aerodrome',
  'Aeromot','Aeronca','Aeroprakt Ltd','Aeroprogress','Aerospatiale','Aerosport','Air Command',
  'Air Creation','Air Tractor','Aircraft Technologies Inc','Akrotech','Alpi Aviation','Ambrosini',
  'American Champion','American Legend','Anderson, Greenwood & Co','ANG Patriot UA','Antonov',
  'Applebay Aviation','Arnet Pereyra','Arv','Asap','Atec','Atr','Auster','Aviastroitel','Aviat',
  'Aviatika','Aviation Norman Dube','Avid','Ayres','Bac','Bae','Bakeng Duece',
  'Barney Oldfield Aircraft Company','Beaver','Bede','Beechcraft','Bell','Bellanca','Beriev',
  'Bettsm','Boeing','Boeing/Stearman','Bolkow','Boothby','Bowers','Bradley','Breezy','Bristol',
  'British Aerospace','Britten Norman','Brush Master','Buccaneer','Bucker Jungmann',
  'Bucker Jungmeister','Buethe Enterprises','Calvin Parker','Canadair',
  'Canadian Home Rotors, Inc.','Capella','Casa','Casa Saeta','Casbon','Cassutt','Cessna',
  'Cfm Aircraft','Cgs','CH-7','Champion','China Xian Aircraft Co','Chris Tena','Christavia',
  'Christen','Co-Z Develpment Corp','Commander','Commonwealth','Commonwealth Aircraft Corp',
  'Composite Jet','Consolidated','Consolidated Vultee','Convair','Coot','Corben','Corby',
  'Cubcrafters','Culver','Curtiss','Curtiss-Wright','D Apuzzo','Damler','Davis Aircraft Corp',
  'Dehavilland','Denemark Eric G','Dornier','Douglas','Dream Aircraft','Dynaero','Eaa Biplane',
  'Eads/PZL','Eads/Socata','Eagle R&D','Eaglerock','Earthstar','EDI','Edmunds','Embraer','Epic',
  'Ercoupe','Europa','Evans','Explorer Aviation','Express','Extra Aircraft','Fairchild','Fairey',
  'Falcon','Falconar','Farrar Davis','Fisher','Fleet','Flightstar','Flying K Enterprises',
  'Focke Wulf','Fokker','Folland','Forster','Fouga','Fournier','Frison','Gaf','Garner','General',
  'Glasair','Golder Circle Air','Great Plains','Grega','Groen Bros','Grumman','Gulfstream',
  'Gut Works','Hamilton','Harmon','Harper-Behr Alyson','Hatz','Hatz/Kelly D','Hawk','Hawker',
  'Hawker Siddeley','HB-Flugtechnik','Helio','Hildreth','Hipps Superbirds','Holmes Milton N',
  'Howard','Iar S.a. Brasov','Ikarus','Ilyushin','Iniziative Industriali','Interavia',
  'International','Interstate','Ipe Aeronaves','Ison','Jabiru','Javelin','Jet Provost','Jodel',
  'Johnny Morris','K & S','K-Meyer','Keleher','Ken Brock','Kingfisher','Kinner','Kit Fox','Klemm',
  'Lancair','Langhurst','Laser','Legend','Legendary','Let','Lewinski Roman','Leza Lockwood',
  'Lockheed','Loehle','Luscombe','Macchi','Marcel Jurca','Maule','Max Holste','MBB',
  'Mcdonnell Douglas','Mcfee E Donald','Merlin','Midget','Midwest Aerosport','Mikoyan','Miles',
  'Mince','Mitchell Wing','Mitsubishi','Mong Sport','Monnett','Monocoupe','Morane-Saulnier',
  'Mosler Motors','Murphy','Mustang Aeronautics','Nanchang','Navy','Nesmith','New Standard',
  'Nieuport','Nomad','Noorduyne','Nord','North American','Northrop','Nuwaco','Osprey Aircraft',
  'Pacific Aerospace','Papa 51 Ltd. Co.','Partenavia / Vulcanair','Pegasus Aviation','Phillips',
  'Piaggio','Pietenpol','Pilatus','Piper','Piper-Sterling','Pitts','Polliwagen','Porterfield',
  'Potez-Heinkel','Prescott Aeronautical','Produits Aviatech Inc','Progressive',
  'Progressive Aerodyne','Protech','Prowler Aviation','Pulsar','Pzl','Pzl-Mielec',
  'Quest Aircraft','Questair','Quickie Aircraft Corp.','Quicksilver','Quikkit','Rand Robinson',
  'Rans','Rearwin','Reflex Fiberglass Works','Refly','Repeat','Revolution','Rhein-Flugzeugbau',
  'Rihn','Riley','Rockwell','Rose','Rotary Air Force','Russell','Rutan','Rutten','Ryan',
  'S.G Aviation','Sa Ravin','Saab','Sabre Aircraft','Saint Louis','Seabird Amphibian','Seawind',
  'Sequoia','Shorts','Siai Marchetti','Sibley Micheal D','Sikorsky','Silhouette','Skyfly',
  'Slepcev Aircraft Company','Slipstream','Smith','Smyth','Soko','Sokol','Sonex','Sopwith',
  'Sorrell Aircraft','Spartan','Speed','Spencer Aircraft','Spezio','Sport Copeter','Sportavia',
  'Sports Aviation','Stampe','Star-Lite','Staudacher','Steen','Stewart','Stinson','Stits','Stolp',
  'Stout/Ford','Sukhoi','Swearingen','Swift','Tapanee','Taylor','Taylorcraft','Team Rocket',
  'Team Tango','Technoavia','Tecnam','Temco','Thorp','Titan','Travel Air','Tri-R Technologies',
  'Trojan','Tupolev','Turbine Cubs','Turner','Ultimate','Ultravia Aero','Vancraft','Vans',
  'Vector','Velocity Aircraft','Vertical Aviation Technologies','Viking','Vought','Vulcanair',
  'Waco','Wag Aero','War Aircraft Replicas','Warner Aircraft','Wd Flugzeugleichtbau Gmbh',
  'Weedhopper','Wheeler','Wittman','Woodwind','Woody Pusher','WSK-pzl-Mielec','Yakovlev',
  'Zenair/Zenith','Zia','Zivko','Zlin',
  'OTHERS'
];

const JET_MANUFACTURERS = [
  'Adam Aircraft','Aero','Aerocomp Inc.','Aerospatiale','Airbus','Antonov','Astra/Gulfstream',
  'Bac','Bae','Beechcraft','Beriev','Boeing','Bombardier','Bombardier/Challenger',
  'British Aerospace','Canadair','Cessna','Cirrus','Comac','Commander','Convair','Dassault',
  'Diamond','Eclipse','Embraer','Epic','Eviation','Excel-Jet','Fairchild Dornier','Fokker',
  'Gulfstream','Hawker','Hawker Beechcraft','Honda','IAI','Ilyushin','Learjet','Lockheed',
  'Maverick Jets','MBB','Mcdonnel Douglas','Mikoyan','Mitsubishi','Morane-Saulnier','Pilatus',
  'Piper','Rhein-Flughzeugbau','Rockwell','Sabre','Safire','SIno Swearingen','Sukhoi','Tupolev',
  'Viper Aircraft Corp','Westwind','Yakovlev',
  'OTHERS'
];

const HELI_MANUFACTURERS = [
  'Aerokopter','Aerospatiale','Agusta','Air & Space','Airbus','AK1-3','Bell',
  'Bell Agusta Aerospace','Beriev','Bolkow','Brantly','Canadian Home Rotors, Inc.','CH-7',
  'Continental Copters','Enstrom','Eurocopter','Fairchild Hiller','Fama','Guimbal','Hiller',
  'Hughes','Kaman','Konner','Mcculloch','Mcdonnell Douglas','Messerschmitt','Mil','Pzl',
  'Rhein-Flugzeugbau','Robinson','Rotorway','Schweizer','Scorpion','Sikorsky','Softex',
  'Texas Helicopter','Vertical Aviation',
  'OTHERS'
];

const STEPS = ['Categoria', 'Dettagli', 'Immagini', 'Revisione'];

const LISTING_PLANS = [
  {
    id: 'base',
    label: 'Base',
    tagline: 'Per chi vuole vendere velocemente',
    price: 4.90,
    priceLabel: '€4,90',
    duration: '6 mesi',
    photos: 5,
    features: ['Durata 6 mesi', 'Fino a 5 foto', 'Visibilità standard', 'Messaggistica integrata'],
    available: true,
  },
  {
    id: 'pro',
    label: 'Pro',
    tagline: 'Più tempo, più visibilità',
    price: 14.90,
    priceLabel: '€14,90',
    duration: '12 mesi',
    photos: 7,
    features: ['Durata 12 mesi', 'Fino a 7 foto', 'Visibilità online extra', 'Messaggistica integrata'],
    available: true,
  },
  {
    id: 'premium',
    label: 'Premium',
    tagline: 'Per velivoli di alto valore',
    price: 39.90,
    priceLabel: '€39,90',
    duration: 'Fino alla vendita',
    photos: 10,
    features: ['Senza scadenza', 'Fino a 10 foto', 'Visibilità online ultra', 'Messaggistica integrata'],
    available: true,
  },
];

function LocationAutocomplete({ value, onChange }) {
  const [query, setQuery] = useState(value || '');
  const [results, setResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const timerRef = useRef(null);
  const { isLoaded } = useGoogleMaps();
  const autocompleteService = useRef(null);

  useEffect(() => {
    if (isLoaded && !autocompleteService.current) {
      autocompleteService.current = new window.google.maps.places.AutocompleteService();
    }
  }, [isLoaded]);

  const search = (q) => {
    setQuery(q);
    if (timerRef.current) clearTimeout(timerRef.current);
    if (q.length < 2) { setResults([]); setShowResults(false); return; }
    timerRef.current = setTimeout(() => {
      if (autocompleteService.current) {
        autocompleteService.current.getPlacePredictions(
          { input: q, types: ['(regions)'] },
          (predictions, status) => {
            if (status === 'OK' && predictions) {
              setResults(predictions.map(p => ({
                description: p.description,
                place_id: p.place_id,
                // Flag country entries visually
                is_country: (p.types || []).includes('country'),
              })));
              setShowResults(true);
            } else {
              // Fallback to backend Nominatim
              fetchNominatim(q);
            }
          }
        );
      } else {
        fetchNominatim(q);
      }
    }, 300);
  };

  const fetchNominatim = async (q) => {
    try {
      const res = await axios.get(`${API}/places/autocomplete`, { params: { q } });
      setResults(res.data.map(r => ({ description: r.description, lat: r.lat, lng: r.lng })));
      setShowResults(true);
    } catch { setResults([]); }
  };

  const select = async (r) => {
    setQuery(r.description);
    setShowResults(false);
    if (r.place_id && isLoaded) {
      const service = new window.google.maps.places.PlacesService(document.createElement('div'));
      service.getDetails({ placeId: r.place_id, fields: ['formatted_address', 'geometry'] }, (place) => {
        if (place?.geometry) {
          onChange(place.formatted_address || r.description, place.geometry.location.lat(), place.geometry.location.lng());
        } else {
          onChange(r.description, 0, 0);
        }
      });
    } else {
      onChange(r.description, r.lat || 0, r.lng || 0);
    }
  };

  return (
    <div className="relative">
      <input
        type="text"
        value={query}
        onChange={e => search(e.target.value)}
        onFocus={() => results.length > 0 && setShowResults(true)}
        onBlur={() => setTimeout(() => setShowResults(false), 200)}
        placeholder="Cerca città o nazione (es. Milano, Italia)..."
        className="flex h-11 w-full border border-zinc-800 bg-zinc-900 px-3 py-2 text-sm text-white placeholder-zinc-500 outline-none focus:border-[#C5A059] transition-colors"
        data-testid="location-autocomplete"
      />
      {showResults && results.length > 0 && (
        <div className="absolute z-30 top-full mt-1 w-full bg-zinc-900 border border-zinc-700 max-h-48 overflow-auto">
          {results.map((r, i) => (
            <button key={i} type="button" onMouseDown={() => select(r)} className="flex w-full items-center gap-2 text-left px-3 py-2.5 text-sm text-zinc-300 hover:bg-zinc-800 hover:text-white border-b border-zinc-800 last:border-0">
              {r.is_country && <span className="text-[9px] font-mono uppercase tracking-wider bg-[#C5A059]/15 text-[#C5A059] px-1.5 py-0.5 shrink-0">Nazione</span>}
              <span className="truncate">{r.description}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function ManufacturerSearch({ value, onChange, manufacturers }) {
  const [query, setQuery] = useState(value);
  const [showList, setShowList] = useState(false);
  const filtered = query
    ? manufacturers.filter(m => {
        const normalizedM = m.toLowerCase().replace(/[.\-\/,&()]/g, '').replace(/\s+/g, ' ');
        const normalizedQ = query.toLowerCase().replace(/[.\-\/,&()]/g, '').replace(/\s+/g, ' ');
        return m.toLowerCase().includes(query.toLowerCase()) || normalizedM.includes(normalizedQ);
      })
    : manufacturers;

  return (
    <div className="relative">
      <Input
        value={query}
        onChange={e => { setQuery(e.target.value); setShowList(true); }}
        onFocus={() => setShowList(true)}
        placeholder="Cerca costruttore..."
        className="bg-zinc-900 border-zinc-800 text-white h-11"
        data-testid="manufacturer-search"
      />
      {!query && !showList && (
        <p className="text-[10px] text-zinc-600 mt-1">Se il costruttore non è presente in lista, seleziona OTHERS</p>
      )}
      {showList && filtered.length > 0 && (
        <div className="absolute z-30 top-full mt-1 w-full bg-zinc-900 border border-zinc-700 max-h-48 overflow-auto">
          {filtered.map(m => (
            <button
              key={m}
              type="button"
              onClick={() => { onChange(m); setQuery(m); setShowList(false); }}
              className="block w-full text-left px-3 py-2 text-sm text-zinc-300 hover:bg-zinc-800 hover:text-white"
            >
              {m}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default function CreateListing() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [planId, setPlanId] = useState('base');
  const [featuredAddon, setFeaturedAddon] = useState(false);
  const [planConfirmed, setPlanConfirmed] = useState(false);
  const [firstListingFree, setFirstListingFree] = useState(false);
  const [saving, setSaving] = useState(false);
  const [listingId, setListingId] = useState(null);
  const [uploadingImages, setUploadingImages] = useState(false);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [uploadedPaths, setUploadedPaths] = useState([]);

  const [form, setForm] = useState({
    category: '',
    manufacturer: '',
    model: '',
    variant: '',
    price: '',
    currency: 'EUR',
    location_city: '',
    location_country: 'Italia',
    location_lat: 0,
    location_lng: 0,
    airport_code: '',
    advanced_ultralight: '',
    condition: 'used',
    year: '',
    last_inspection: '',
    total_time: '',
    total_landings: '',
    seats: '',
    registration: '',
    serial_number: '',
    damage_history: '',
    hangar_kept: false,
    ifr_equipped: false,
    ifr_certified: false,
    commercial_certified: false,
    jar_ops_certified: false,
    engine_type: '',
    engine_hours: '',
    avionics: '',
    max_speed: '',
    range_km: '',
    mtow: '',
    useful_load: '',
    num_engines: '',
    propeller_type: '',
    engine2_hours: '',
    engine3_hours: '',
    engine4_hours: '',
    tbo_remaining: '',
    hot_section_completed: false,
    total_cycles: '',
    apu_hours: '',
    interior_config: '',
    rotor_blades: '',
    rotor_hours: '',
    tail_rotor_hours: '',
    hoist_equipped: false,
    ems_equipped: false,
    nvg_compatible: false,
    description: '',
    status: 'draft',
  });

  // Redirect to login if not authenticated
  useEffect(() => {
    if (!authLoading && !user) {
      navigate('/login', { state: { from: '/create-listing' } });
    }
  }, [user, authLoading, navigate]);

  // Exit confirmation — warn on tab close / refresh / back button if user has made any progress
  const hasUnsavedChanges = step > 0 && form.status !== 'published';
  useEffect(() => {
    if (!hasUnsavedChanges) return;
    const handler = (e) => {
      e.preventDefault();
      e.returnValue = '';
      return '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [hasUnsavedChanges]);

  // Check first-listing-free eligibility (Base plan is gratis for the user's first listing)
  useEffect(() => {
    if (!user) return;
    axios.get(`${API}/me/free-launch-available`, { withCredentials: true })
      .then((r) => {
        setFirstListingFree(!!r.data.available);
      })
      .catch(() => {});
  }, [user]);

  const updateForm = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
    if (validationErrors.length > 0) setValidationErrors([]);
  };
  const [descWarning, setDescWarning] = useState('');
  const [validationErrors, setValidationErrors] = useState([]);

  const handleDescriptionChange = (text) => {
    const hasPhone = /\+\d[\d\s().\-]{6,}|\b3\d{2}[\s.\-]?\d{3}[\s.\-]?\d{3,4}\b|\b\d{10,}\b/.test(text);
    const hasEmail = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/.test(text);
    const hasUrl = /(https?:\/\/|www\.)[^\s]+/i.test(text);
    if (hasPhone || hasEmail || hasUrl) {
      setDescWarning('Numeri di telefono, email e siti web non sono consentiti nella descrizione. Importi, anni e date sono permessi.');
    } else {
      setDescWarning('');
    }
    updateForm('description', text);
  };

  const autoTitle = [form.manufacturer, form.model, form.variant].filter(Boolean).join(' ');

  // Autosave
  useEffect(() => {
    if (!listingId || step < 1) return;
    const timer = setTimeout(async () => {
      try {
        const data = { ...form, title: autoTitle };
        Object.keys(data).forEach(k => { if (data[k] === '') delete data[k]; });
        await axios.put(`${API}/listings/${listingId}`, data, { withCredentials: true });
      } catch { /* silent */ }
    }, 3000);
    return () => clearTimeout(timer);
  }, [form, listingId, step, autoTitle]);

  const createDraft = async () => {
    if (listingId) return;
    try {
      const res = await axios.post(`${API}/listings`, { ...form, title: autoTitle, status: 'draft' }, { withCredentials: true });
      setListingId(res.data.listing_id);
    } catch { /* ignore */ }
  };

  const handleImageUpload = async (files) => {
    // Enforce per-plan photo limit
    const maxPhotos = chosenPlan?.photos || 10;
    const remaining = Math.max(0, maxPhotos - uploadedPaths.length);
    if (remaining === 0) {
      toast.error(`Hai raggiunto il limite di ${maxPhotos} foto per il piano ${chosenPlan?.label}.`);
      return;
    }
    let toUpload = Array.from(files);
    if (toUpload.length > remaining) {
      toast.warning(`Puoi caricare massimo ${maxPhotos} foto con il piano ${chosenPlan?.label}. Verranno aggiunte le prime ${remaining}.`);
      toUpload = toUpload.slice(0, remaining);
    }
    setUploadingImages(true);
    const newPreviews = [];
    const newPaths = [];
    for (const file of toUpload) {
      newPreviews.push(URL.createObjectURL(file));
      const fd = new FormData();
      fd.append('file', file);
      try {
        const res = await axios.post(`${API}/upload`, fd, { withCredentials: true });
        newPaths.push(res.data.path);
      } catch { /* skip */ }
    }
    setImagePreviews(prev => [...prev, ...newPreviews]);
    setUploadedPaths(prev => [...prev, ...newPaths]);
    setUploadingImages(false);
  };

  const removeImage = (idx) => {
    setImagePreviews(prev => prev.filter((_, i) => i !== idx));
    setUploadedPaths(prev => prev.filter((_, i) => i !== idx));
  };

  const moveImage = (fromIdx, toIdx) => {
    if (toIdx < 0 || toIdx >= imagePreviews.length) return;
    setImagePreviews(prev => {
      const arr = [...prev];
      [arr[fromIdx], arr[toIdx]] = [arr[toIdx], arr[fromIdx]];
      return arr;
    });
    setUploadedPaths(prev => {
      const arr = [...prev];
      [arr[fromIdx], arr[toIdx]] = [arr[toIdx], arr[fromIdx]];
      return arr;
    });
  };

  const handleImageDragStart = (e, idx) => {
    e.dataTransfer.setData('text/plain', idx.toString());
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleImageDrop = (e, toIdx) => {
    e.preventDefault();
    const fromIdx = parseInt(e.dataTransfer.getData('text/plain'));
    if (fromIdx !== toIdx) moveImage(fromIdx, toIdx);
  };

  const validateStep1 = () => {
    const errors = [];
    if (!form.manufacturer) errors.push('Costruttore');
    if (!form.model) errors.push('Modello');
    if (!form.price) errors.push('Prezzo');
    if (!form.location_city) errors.push('Posizione');
    if (!form.year) errors.push('Anno di Costruzione');
    if (!form.condition) errors.push('Condizioni');
    if (!form.registration) errors.push('Registrazione / Tail Number');
    if (!form.damage_history) errors.push('Storico Danni');
    if (!form.total_time) errors.push('Ore Airframe');
    if (form.category === 'ultraleggeri' && !form.advanced_ultralight) errors.push('Ultraleggero Avanzato');
    return errors;
  };

  const handleNext = async () => {
    if (step === 0 && !form.category) return;
    if (step === 0) await createDraft();
    if (step === 1) {
      const errors = validateStep1();
      if (errors.length > 0) {
        setValidationErrors(errors);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      setValidationErrors([]);
    }
    if (step === 2 && uploadedPaths.length === 0) {
      setValidationErrors(['Carica almeno 1 immagine per proseguire']);
      return;
    }
    setValidationErrors([]);
    if (step < STEPS.length - 1) setStep(step + 1);
  };

  const handlePublish = async () => {
    setSaving(true);
    try {
      const data = { ...form, title: autoTitle, status: 'published', images: uploadedPaths, plan: planId };
      if (data.description) {
        data.description = data.description
          .replace(/\+\d[\d\s().\-]{6,}/g, '***')
          .replace(/\b3\d{2}[\s.\-]?\d{3}[\s.\-]?\d{3,4}\b/g, '***')
          .replace(/\b\d{10,}\b/g, '***')
          .replace(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g, '***')
          .replace(/(https?:\/\/|www\.)[^\s]+/gi, '***');
      }
      Object.keys(data).forEach(k => { if (data[k] === '') delete data[k]; });
      let createdListingId = listingId;
      let response;
      if (listingId) {
        response = await axios.put(`${API}/listings/${listingId}`, data, { withCredentials: true });
        if (uploadedPaths.length > 0) {
          await axios.post(`${API}/listings/${listingId}/images`, { images: uploadedPaths }, { withCredentials: true });
        }
      } else {
        response = await axios.post(`${API}/listings`, data, { withCredentials: true });
        createdListingId = response?.data?.listing_id || createdListingId;
      }

      // Paid plan → redirect to Stripe Checkout
      if (response?.data?.requires_payment && response?.data?.checkout_package_id) {
        const { data: sess } = await axios.post(
          `${API}/checkout/session`,
          {
            package_id: response.data.checkout_package_id,
            origin_url: window.location.origin,
            listing_id: createdListingId,
            featured_addon: featuredAddon,
          },
          { withCredentials: true }
        );
        if (sess?.url) {
          window.location.href = sess.url;
          return;
        }
        alert('Impossibile avviare il pagamento. Riprova.');
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      const msg = err?.response?.data?.detail;
      if (msg) alert(msg);
    }
    setSaving(false);
  };

  if (authLoading) return (
    <div className="min-h-screen bg-[#09090B] pt-20 flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-[#C5A059] border-t-transparent rounded-full animate-spin" />
    </div>
  );

  if (!user) return null;

  const chosenPlan = LISTING_PLANS.find((p) => p.id === planId) || LISTING_PLANS[0];

  // Effective price view: Base is gratis for the user's first listing
  const isFirstFreeBase = chosenPlan.id === 'base' && firstListingFree;
  const effectivePrice = isFirstFreeBase ? 0 : chosenPlan.price;

  // ─── Plan Selection Screen (shown before wizard) ───
  if (!planConfirmed) {
    return (
      <div className="min-h-screen bg-[#09090B] pt-20" data-testid="plan-selection-page">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="mb-12">
            <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#C5A059] mb-3">Nuovo Annuncio · Step 1 di 2</p>
            <h1 className="text-3xl md:text-4xl tracking-tighter font-medium text-white mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
              Scegli il piano per il tuo annuncio
            </h1>
            <p className="text-sm text-zinc-400 max-w-2xl leading-relaxed">
              {firstListingFree
                ? 'Il tuo primo annuncio è gratis con il piano Base. Per pubblicarne altri scegli un piano a pagamento — paghi una sola volta, niente abbonamenti.'
                : 'Scegli il piano per il tuo annuncio. Paghi una sola volta, niente abbonamenti.'}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
            {LISTING_PLANS.map((p) => {
              const selected = planId === p.id;
              const disabled = !p.available;
              const isBaseFree = p.id === 'base' && firstListingFree;
              return (
                <button
                  key={p.id}
                  onClick={() => !disabled && setPlanId(p.id)}
                  disabled={disabled}
                  className={`relative text-left p-6 border transition-all flex flex-col ${
                    disabled
                      ? 'border-zinc-900 bg-zinc-950/50 opacity-55 cursor-not-allowed'
                      : selected
                      ? 'border-[#C5A059] bg-[#C5A059]/[0.07]'
                      : 'border-zinc-800 bg-zinc-900/40 hover:border-zinc-600'
                  }`}
                  data-testid={`plan-${p.id}`}
                >
                  {isBaseFree && (
                    <span className="absolute -top-3 left-5 text-[9px] font-mono uppercase tracking-widest bg-[#C5A059] text-black px-2.5 py-1">Primo annuncio gratis</span>
                  )}
                  {!p.available && (
                    <span className="absolute -top-3 right-5 text-[9px] font-mono uppercase tracking-widest bg-zinc-800 text-zinc-500 px-2.5 py-1">Presto</span>
                  )}
                  <div className="flex items-baseline justify-between mb-1">
                    <span className="text-xs font-mono uppercase tracking-widest text-[#C5A059]">{p.label}</span>
                    {selected && p.available && <Check size={14} className="text-[#C5A059]" />}
                  </div>
                  <div className="text-xs text-zinc-500 mb-5">{p.tagline}</div>
                  <div className="mb-5">
                    {isBaseFree ? (
                      <div className="flex items-baseline gap-2">
                        <span className="text-base text-zinc-500 line-through">{p.priceLabel}</span>
                        <span className="text-3xl text-white font-medium" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Gratis</span>
                      </div>
                    ) : (
                      <div className="text-3xl text-white font-medium" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>{p.priceLabel}</div>
                    )}
                    <div className="text-[11px] text-zinc-500 mt-1">{p.duration} · {p.photos} foto</div>
                  </div>
                  <ul className="space-y-2 flex-1 mb-2">
                    {p.features.map((f) => (
                      <li key={f} className={`flex items-start gap-2 text-xs leading-relaxed ${disabled ? 'text-zinc-600' : 'text-zinc-400'}`}>
                        <Check size={12} className={`mt-0.5 shrink-0 ${disabled ? 'text-zinc-700' : 'text-[#C5A059]'}`} />
                        <span>{f}</span>
                      </li>
                    ))}
                  </ul>
                </button>
              );
            })}
          </div>

          {/* Featured Add-on Cross-sell (paid plans only — disabled for free first listing) */}
          {effectivePrice > 0 && (
            <div
              className={`border p-5 mb-6 transition-all ${
                featuredAddon ? 'border-[#C5A059] bg-[#C5A059]/[0.06]' : 'border-zinc-800 bg-zinc-900/40'
              }`}
              data-testid="featured-addon-card"
            >
              <label className="flex items-start gap-4 cursor-pointer">
                <input
                  type="checkbox"
                  checked={featuredAddon}
                  onChange={(e) => setFeaturedAddon(e.target.checked)}
                  className="mt-1 w-4 h-4 accent-[#C5A059] cursor-pointer"
                  data-testid="featured-addon-toggle"
                />
                <div className="flex-1">
                  <div className="flex items-center justify-between gap-3 flex-wrap">
                    <div className="flex items-center gap-2">
                      <Star size={14} className="text-[#C5A059]" />
                      <span className="text-sm font-medium text-white">Aggiungi In Evidenza per 30 giorni</span>
                    </div>
                    <span className="text-sm font-medium text-[#C5A059]">+ €9,90</span>
                  </div>
                  <p className="text-xs text-zinc-500 mt-1.5 leading-relaxed">
                    Il tuo annuncio apparirà in cima ai risultati di ricerca, sezione "In Evidenza" in homepage e badge dorato per 30 giorni.
                  </p>
                </div>
              </label>
            </div>
          )}

          <div className="flex items-center justify-between border-t border-zinc-800 pt-6">
            <div className="text-xs text-zinc-500">
              Piano selezionato: <span className="text-white font-medium">{chosenPlan.label}</span> · <span className="text-[#C5A059]">{isFirstFreeBase ? 'Gratis' : chosenPlan.priceLabel}</span>
              {featuredAddon && effectivePrice > 0 && (
                <> · <span className="text-[#C5A059]">+ In Evidenza €9,90</span> · <span className="text-white">Totale €{(effectivePrice + 9.90).toFixed(2).replace('.', ',')}</span></>
              )}
            </div>
            <button
              onClick={() => setPlanConfirmed(true)}
              className="inline-flex items-center gap-2 bg-[#C5A059] text-black px-6 py-3 text-sm font-medium hover:bg-[#D4B271] transition-colors"
              data-testid="plan-confirm-btn"
            >
              Continua con {chosenPlan.label} <ArrowRight size={16} />
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#09090B] pt-20" data-testid="create-listing-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Plan badge on top */}
        <button
          onClick={() => setPlanConfirmed(false)}
          className="mb-6 inline-flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-zinc-500 hover:text-[#C5A059] transition-colors"
          data-testid="change-plan-btn"
        >
          <ArrowLeft size={12} /> Piano: {chosenPlan.label} · {isFirstFreeBase ? 'Gratis' : chosenPlan.priceLabel} · cambia
        </button>        {/* Step Indicator */}
        <div className="flex items-center gap-2 mb-12" data-testid="wizard-steps">
          {STEPS.map((s, i) => (
            <div key={s} className="flex items-center">
              <button
                onClick={() => i <= step && setStep(i)}
                className={`w-8 h-8 flex items-center justify-center text-xs font-mono ${
                  i < step ? 'step-complete' : i === step ? 'step-active' : 'step-pending'
                }`}
                data-testid={`wizard-step-${i}`}
              >
                {i < step ? <Check size={14} /> : i + 1}
              </button>
              {i < STEPS.length - 1 && <div className={`w-8 h-px ${i < step ? 'bg-[#C5A059]' : 'bg-zinc-800'}`} />}
            </div>
          ))}
          <span className="ml-4 text-sm text-zinc-500">{STEPS[step]}</span>
        </div>

        {/* Step 0: Category */}
        {step === 0 && (
          <div className="space-y-4 animate-fade-in" data-testid="step-category">
            <h2 className="text-2xl font-medium text-white mb-6" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Seleziona Categoria</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {CATEGORIES.map(cat => (
                <button
                  key={cat.slug}
                  onClick={() => updateForm('category', cat.slug)}
                  className={`text-left p-4 border transition-all ${form.category === cat.slug ? 'border-[#C5A059] bg-[#C5A059]/5' : 'border-zinc-800 hover:border-zinc-600 bg-zinc-900/30'}`}
                  data-testid={`cat-option-${cat.slug}`}
                >
                  <span className={`text-sm font-medium ${form.category === cat.slug ? 'text-[#C5A059]' : 'text-zinc-300'}`}>{cat.name}</span>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Step 1: Details (Category-specific) */}
        {step === 1 && (
          <div className="space-y-6 animate-fade-in" data-testid="step-details">
            <div>
              <h2 className="text-2xl font-medium text-white mb-2" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Dettagli Annuncio</h2>
              {autoTitle && (
                <p className="text-sm text-[#C5A059] font-mono">Titolo: {autoTitle}</p>
              )}
            </div>

            {validationErrors.length > 0 && (
              <div className="flex items-start gap-3 p-4 bg-red-500/10 border border-red-500/30" data-testid="validation-errors">
                <AlertTriangle size={18} className="text-red-400 shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm font-medium text-red-400 mb-1">Compila i campi obbligatori per proseguire:</p>
                  <p className="text-xs text-red-300/80">{validationErrors.join(', ')}</p>
                </div>
              </div>
            )}

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {/* Manufacturer */}
              <div className="col-span-2 sm:col-span-1">
                <Label className="text-zinc-400 text-xs mb-1.5 block">Costruttore *</Label>
                <ManufacturerSearch
                  value={form.manufacturer}
                  onChange={v => updateForm('manufacturer', v)}
                  manufacturers={form.category === 'propulsione-multipla' ? MULTI_ENGINE_MANUFACTURERS : form.category === 'turboelica' ? TURBOPROP_MANUFACTURERS : form.category === 'jet' ? JET_MANUFACTURERS : form.category === 'elicotteri' ? HELI_MANUFACTURERS : ALL_MANUFACTURERS}
                />
              </div>

              {/* Model */}
              <div>
                <Label className="text-zinc-400 text-xs mb-1.5 block">Modello *</Label>
                <Input value={form.model} onChange={e => updateForm('model', e.target.value)} placeholder={
                  form.category === 'ultraleggeri' ? 'Es: P92 Echo' :
                  form.category === 'propulsione-singola' ? 'Es: SR22T' :
                  form.category === 'propulsione-multipla' ? 'Es: DA62' :
                  form.category === 'turboelica' ? 'Es: PC-12 NGX' :
                  form.category === 'jet' ? 'Es: Citation CJ4' :
                  form.category === 'elicotteri' ? 'Es: R44 Raven II' : 'Es: modello'
                } className="bg-zinc-900 border-zinc-800 text-white h-11" data-testid="input-model" />
              </div>

              {/* Variant */}
              <div>
                <Label className="text-zinc-400 text-xs mb-1.5 block">Variante</Label>
                <Input value={form.variant} onChange={e => updateForm('variant', e.target.value)} placeholder={
                  form.category === 'ultraleggeri' ? 'Es: MkII' :
                  form.category === 'propulsione-singola' ? 'Es: GTS' :
                  form.category === 'propulsione-multipla' ? 'Es: VI' :
                  form.category === 'turboelica' ? 'Es: NG' :
                  form.category === 'jet' ? 'Es: Gen2' :
                  form.category === 'elicotteri' ? 'Es: II' : 'Es: variante'
                } className="bg-zinc-900 border-zinc-800 text-white h-11" data-testid="input-variant" />
              </div>

              {/* Price */}
              <div>
                <Label className="text-zinc-400 text-xs mb-1.5 block">Prezzo (EUR) *</Label>
                <Input type="number" value={form.price} onChange={e => updateForm('price', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11" data-testid="input-price" />
              </div>

              {/* Location */}
              <div className="col-span-2 sm:col-span-1">
                <Label className="text-zinc-400 text-xs mb-1.5 block">Posizione *</Label>
                <LocationAutocomplete
                  value={form.location_city}
                  onChange={(city, lat, lng) => {
                    updateForm('location_city', city);
                    if (lat) updateForm('location_lat', lat);
                    if (lng) updateForm('location_lng', lng);
                  }}
                />
              </div>

              {/* Airport Code */}
              <div>
                <Label className="text-zinc-400 text-xs mb-1.5 block">Codice Aeroporto</Label>
                <Input value={form.airport_code} onChange={e => updateForm('airport_code', e.target.value.toUpperCase())} placeholder="Es: LIML" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono uppercase" data-testid="input-airport" />
              </div>

              {/* Advanced Ultralight */}
              {form.category === 'ultraleggeri' && (
                <div>
                  <Label className="text-zinc-400 text-xs mb-1.5 block">Ultraleggero Avanzato *</Label>
                  <Select value={form.advanced_ultralight} onValueChange={v => updateForm('advanced_ultralight', v)}>
                    <SelectTrigger className="bg-zinc-900 border-zinc-800 text-zinc-300 h-11" data-testid="select-advanced"><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                    <SelectContent className="bg-zinc-900 border-zinc-800 z-[100]">
                      <SelectItem value="si" className="text-zinc-300">Si</SelectItem>
                      <SelectItem value="no" className="text-zinc-300">No</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              )}

              {/* Condition */}
              <div>
                <Label className="text-zinc-400 text-xs mb-1.5 block">Condizioni *</Label>
                <Select value={form.condition} onValueChange={v => updateForm('condition', v)}>
                  <SelectTrigger className="bg-zinc-900 border-zinc-800 text-zinc-300 h-11" data-testid="select-condition"><SelectValue /></SelectTrigger>
                  <SelectContent className="bg-zinc-900 border-zinc-800 z-[100]">
                    <SelectItem value="new" className="text-zinc-300">Nuovo</SelectItem>
                    <SelectItem value="used" className="text-zinc-300">Usato</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              {/* Year */}
              <div>
                <Label className="text-zinc-400 text-xs mb-1.5 block">Anno di Costruzione *</Label>
                <Input type="number" value={form.year || ''} onChange={e => updateForm('year', parseInt(e.target.value) || '')} placeholder="Es: 2018" className="bg-zinc-900 border-zinc-800 text-white h-11" data-testid="input-year" />
              </div>

              {/* Last Inspection */}
              <div>
                <Label className="text-zinc-400 text-xs mb-1.5 block">Ultima Ispezione Annuale</Label>
                <Input type="date" value={form.last_inspection} onChange={e => updateForm('last_inspection', e.target.value)} className="bg-zinc-900 border-zinc-800 text-white h-11" data-testid="input-inspection" />
              </div>

              {/* Airframe Hours */}
              <div>
                <Label className="text-zinc-400 text-xs mb-1.5 block">Ore Airframe *</Label>
                <Input type="number" value={form.total_time} onChange={e => updateForm('total_time', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-total-time" />
              </div>

              {/* Total Landings */}
              <div>
                <Label className="text-zinc-400 text-xs mb-1.5 block">Atterraggi Totali</Label>
                <Input type="number" value={form.total_landings} onChange={e => updateForm('total_landings', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-landings" />
              </div>

              {/* Seats - for non-ultralight categories */}
              {form.category !== 'ultraleggeri' && (
                <div>
                  <Label className="text-zinc-400 text-xs mb-1.5 block">Posti Totali (PIC + PAX)</Label>
                  <Input type="number" value={form.seats} onChange={e => updateForm('seats', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11" data-testid="input-seats" />
                </div>
              )}

              {/* Registration */}
              <div className="col-span-2">
                <Label className="text-zinc-400 text-xs mb-1.5 block">Registrazione / Tail Number *</Label>
                <Input value={form.registration} onChange={e => updateForm('registration', e.target.value.toUpperCase())} placeholder="Es: I-AEDS" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono uppercase" data-testid="input-registration" />
                <div className="flex items-start gap-2 mt-2 p-2.5 bg-amber-500/5 border border-amber-500/20">
                  <AlertTriangle size={14} className="text-amber-500 shrink-0 mt-0.5" />
                  <p className="text-[11px] text-amber-400/80 leading-snug">
                    La registrazione verr&agrave; verificata. Annunci con registrazioni false o inesistenti non verranno pubblicati.
                  </p>
                </div>
              </div>

              {/* Serial Number */}
              <div>
                <Label className="text-zinc-400 text-xs mb-1.5 block">Numero di Serie</Label>
                <Input value={form.serial_number} onChange={e => updateForm('serial_number', e.target.value)} className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-serial" />
              </div>

              {/* Damage History */}
              <div>
                <Label className="text-zinc-400 text-xs mb-1.5 block">Storico Danni *</Label>
                <Select value={form.damage_history} onValueChange={v => updateForm('damage_history', v)}>
                  <SelectTrigger className="bg-zinc-900 border-zinc-800 text-zinc-300 h-11" data-testid="select-damage"><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                  <SelectContent className="bg-zinc-900 border-zinc-800 z-[100]">
                    <SelectItem value="never" className="text-zinc-300">Mai danneggiato</SelectItem>
                    <SelectItem value="yes" className="text-zinc-300">Si, danneggiato in precedenza</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              {/* Engine Type */}
              <div>
                <Label className="text-zinc-400 text-xs mb-1.5 block">Tipo Motore</Label>
                <Input value={form.engine_type} onChange={e => updateForm('engine_type', e.target.value)} placeholder={
                  form.category === 'ultraleggeri' ? 'Es: Rotax 912 ULS' :
                  form.category === 'propulsione-singola' ? 'Es: Continental IO-550' :
                  form.category === 'propulsione-multipla' ? 'Es: Austro Engine AE330' :
                  form.category === 'turboelica' ? 'Es: Pratt & Whitney PT6A' :
                  form.category === 'jet' ? 'Es: Williams FJ44' :
                  form.category === 'elicotteri' ? 'Es: Lycoming O-540' : 'Es: tipo motore'
                } className="bg-zinc-900 border-zinc-800 text-white h-11" data-testid="input-engine-type" />
              </div>

              {/* Engine Hours */}
              <div>
                <Label className="text-zinc-400 text-xs mb-1.5 block">Ore Motore</Label>
                <Input type="number" value={form.engine_hours} onChange={e => updateForm('engine_hours', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-engine-hours" />
              </div>

              {/* Num engines + extra engine hours BEFORE avionics */}
              {form.category === 'propulsione-multipla' && (
                <>
                  <div>
                    <Label className="text-zinc-400 text-xs mb-1.5 block">Numero Motori</Label>
                    <Select value={form.num_engines || ''} onValueChange={v => updateForm('num_engines', v)}>
                      <SelectTrigger className="bg-zinc-900 border-zinc-800 text-zinc-300 h-11" data-testid="select-num-engines"><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent className="bg-zinc-900 border-zinc-800 z-[100]">
                        <SelectItem value="2" className="text-zinc-300">2</SelectItem>
                        <SelectItem value="3" className="text-zinc-300">3</SelectItem>
                        <SelectItem value="4" className="text-zinc-300">4</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label className="text-zinc-400 text-xs mb-1.5 block">Ore Motore 2</Label>
                    <Input type="number" value={form.engine2_hours} onChange={e => updateForm('engine2_hours', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-engine2-hours" />
                  </div>
                  {parseInt(form.num_engines) >= 3 && (
                    <div>
                      <Label className="text-zinc-400 text-xs mb-1.5 block">Ore Motore 3</Label>
                      <Input type="number" value={form.engine3_hours} onChange={e => updateForm('engine3_hours', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-engine3-hours" />
                    </div>
                  )}
                  {parseInt(form.num_engines) >= 4 && (
                    <div>
                      <Label className="text-zinc-400 text-xs mb-1.5 block">Ore Motore 4</Label>
                      <Input type="number" value={form.engine4_hours} onChange={e => updateForm('engine4_hours', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-engine4-hours" />
                    </div>
                  )}
                </>
              )}

              {form.category === 'turboelica' && (
                <>
                  <div>
                    <Label className="text-zinc-400 text-xs mb-1.5 block">Numero Motori</Label>
                    <Select value={form.num_engines || ''} onValueChange={v => updateForm('num_engines', v)}>
                      <SelectTrigger className="bg-zinc-900 border-zinc-800 text-zinc-300 h-11" data-testid="select-num-engines"><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent className="bg-zinc-900 border-zinc-800 z-[100]">
                        <SelectItem value="1" className="text-zinc-300">1</SelectItem>
                        <SelectItem value="2" className="text-zinc-300">2</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  {parseInt(form.num_engines) >= 2 && (
                    <div>
                      <Label className="text-zinc-400 text-xs mb-1.5 block">Ore Motore 2</Label>
                      <Input type="number" value={form.engine2_hours} onChange={e => updateForm('engine2_hours', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-engine2-hours" />
                    </div>
                  )}
                </>
              )}

              {form.category === 'jet' && (
                <>
                  <div>
                    <Label className="text-zinc-400 text-xs mb-1.5 block">Numero Motori</Label>
                    <Select value={form.num_engines || ''} onValueChange={v => updateForm('num_engines', v)}>
                      <SelectTrigger className="bg-zinc-900 border-zinc-800 text-zinc-300 h-11" data-testid="select-num-engines"><SelectValue placeholder="Seleziona..." /></SelectTrigger>
                      <SelectContent className="bg-zinc-900 border-zinc-800 z-[100]">
                        <SelectItem value="1" className="text-zinc-300">1</SelectItem>
                        <SelectItem value="2" className="text-zinc-300">2</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  {parseInt(form.num_engines) >= 2 && (
                    <div>
                      <Label className="text-zinc-400 text-xs mb-1.5 block">Ore Motore 2</Label>
                      <Input type="number" value={form.engine2_hours} onChange={e => updateForm('engine2_hours', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-engine2-hours" />
                    </div>
                  )}
                  <div>
                    <Label className="text-zinc-400 text-xs mb-1.5 block">Cicli Totali</Label>
                    <Input type="number" value={form.total_cycles} onChange={e => updateForm('total_cycles', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-cycles" />
                  </div>
                  <div>
                    <Label className="text-zinc-400 text-xs mb-1.5 block">Ore APU</Label>
                    <Input type="number" value={form.apu_hours} onChange={e => updateForm('apu_hours', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-apu" />
                  </div>
                </>
              )}

              {/* Avionics */}
              <div className="col-span-2">
                <Label className="text-zinc-400 text-xs mb-1.5 block">Avionica</Label>
                <Input value={form.avionics} onChange={e => updateForm('avionics', e.target.value)} placeholder={
                  form.category === 'jet' ? 'Es: Collins Pro Line Fusion' :
                  form.category === 'turboelica' ? 'Es: Honeywell Apex, Garmin G1000' :
                  'Es: Garmin G3X, Dynon SkyView'
                } className="bg-zinc-900 border-zinc-800 text-white h-11" data-testid="input-avionics" />
              </div>

              {/* Helicopter specific: Elicotteri */}
              {form.category === 'elicotteri' && (
                <>
                  <div>
                    <Label className="text-zinc-400 text-xs mb-1.5 block">Pale Rotore Principale</Label>
                    <Input type="number" value={form.rotor_blades} onChange={e => updateForm('rotor_blades', e.target.value)} placeholder="Es: 2" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-rotor-blades" />
                  </div>
                  <div>
                    <Label className="text-zinc-400 text-xs mb-1.5 block">Ore Rotore</Label>
                    <Input type="number" value={form.rotor_hours} onChange={e => updateForm('rotor_hours', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-rotor-hours" />
                  </div>
                  <div>
                    <Label className="text-zinc-400 text-xs mb-1.5 block">Ore Rotore di Coda</Label>
                    <Input type="number" value={form.tail_rotor_hours} onChange={e => updateForm('tail_rotor_hours', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-tail-rotor-hours" />
                  </div>
                  <div>
                    <Label className="text-zinc-400 text-xs mb-1.5 block">TBO Rimanenti (ore)</Label>
                    <Input type="number" value={form.tbo_remaining} onChange={e => updateForm('tbo_remaining', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-tbo" />
                  </div>
                </>
              )}

              {/* Performance fields for ALL categories */}
              <div>
                <Label className="text-zinc-400 text-xs mb-1.5 block">Velocita Max ({form.category === 'ultraleggeri' ? 'km/h' : 'kts'})</Label>
                <Input type="number" value={form.max_speed} onChange={e => updateForm('max_speed', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-max-speed" />
              </div>
              <div>
                <Label className="text-zinc-400 text-xs mb-1.5 block">Autonomia (nm)</Label>
                <Input type="number" value={form.range_km} onChange={e => updateForm('range_km', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-range" />
              </div>
              <div>
                <Label className="text-zinc-400 text-xs mb-1.5 block">MTOW (kg)</Label>
                <Input type="number" value={form.mtow} onChange={e => updateForm('mtow', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-mtow" />
              </div>
              <div>
                <Label className="text-zinc-400 text-xs mb-1.5 block">Carico Utile (kg)</Label>
                <Input type="number" value={form.useful_load} onChange={e => updateForm('useful_load', e.target.value)} placeholder="0" className="bg-zinc-900 border-zinc-800 text-white h-11 font-mono" data-testid="input-useful-load" />
              </div>

              {/* Characteristics */}
              <div className="col-span-2">
                <Label className="text-zinc-400 text-xs mb-2 block">Caratteristiche</Label>
                <div className="space-y-3">
                  <label className="flex items-center gap-3 cursor-pointer group" data-testid="checkbox-hangar">
                    <div className={`w-5 h-5 border flex items-center justify-center transition-colors ${form.hangar_kept ? 'bg-[#C5A059] border-[#C5A059]' : 'border-zinc-700 bg-zinc-900 group-hover:border-zinc-500'}`}>
                      {form.hangar_kept && <Check size={12} className="text-black" />}
                    </div>
                    <input type="checkbox" checked={form.hangar_kept} onChange={e => updateForm('hangar_kept', e.target.checked)} className="hidden" />
                    <span className="text-sm text-zinc-300">Tenuto in hangar</span>
                  </label>

                  {form.category !== 'ultraleggeri' && (
                    <>
                      <label className="flex items-center gap-3 cursor-pointer group" data-testid="checkbox-ifr-equipped">
                        <div className={`w-5 h-5 border flex items-center justify-center transition-colors ${form.ifr_equipped ? 'bg-[#C5A059] border-[#C5A059]' : 'border-zinc-700 bg-zinc-900 group-hover:border-zinc-500'}`}>
                          {form.ifr_equipped && <Check size={12} className="text-black" />}
                        </div>
                        <input type="checkbox" checked={form.ifr_equipped} onChange={e => updateForm('ifr_equipped', e.target.checked)} className="hidden" />
                        <span className="text-sm text-zinc-300">Attrezzato IFR</span>
                      </label>
                      <label className="flex items-center gap-3 cursor-pointer group" data-testid="checkbox-ifr-certified">
                        <div className={`w-5 h-5 border flex items-center justify-center transition-colors ${form.ifr_certified ? 'bg-[#C5A059] border-[#C5A059]' : 'border-zinc-700 bg-zinc-900 group-hover:border-zinc-500'}`}>
                          {form.ifr_certified && <Check size={12} className="text-black" />}
                        </div>
                        <input type="checkbox" checked={form.ifr_certified} onChange={e => updateForm('ifr_certified', e.target.checked)} className="hidden" />
                        <span className="text-sm text-zinc-300">Certificato IFR</span>
                      </label>
                      <label className="flex items-center gap-3 cursor-pointer group" data-testid="checkbox-commercial">
                        <div className={`w-5 h-5 border flex items-center justify-center transition-colors ${form.commercial_certified ? 'bg-[#C5A059] border-[#C5A059]' : 'border-zinc-700 bg-zinc-900 group-hover:border-zinc-500'}`}>
                          {form.commercial_certified && <Check size={12} className="text-black" />}
                        </div>
                        <input type="checkbox" checked={form.commercial_certified} onChange={e => updateForm('commercial_certified', e.target.checked)} className="hidden" />
                        <span className="text-sm text-zinc-300">Certificato Uso Commerciale</span>
                      </label>
                      <label className="flex items-center gap-3 cursor-pointer group" data-testid="checkbox-jar-ops">
                        <div className={`w-5 h-5 border flex items-center justify-center transition-colors ${form.jar_ops_certified ? 'bg-[#C5A059] border-[#C5A059]' : 'border-zinc-700 bg-zinc-900 group-hover:border-zinc-500'}`}>
                          {form.jar_ops_certified && <Check size={12} className="text-black" />}
                        </div>
                        <input type="checkbox" checked={form.jar_ops_certified} onChange={e => updateForm('jar_ops_certified', e.target.checked)} className="hidden" />
                        <span className="text-sm text-zinc-300">Omologato JAR-OPS 1</span>
                      </label>
                    </>
                  )}

                  {/* Helicopter-specific characteristics */}
                  {form.category === 'elicotteri' && (
                    <>
                      <label className="flex items-center gap-3 cursor-pointer group" data-testid="checkbox-hoist">
                        <div className={`w-5 h-5 border flex items-center justify-center transition-colors ${form.hoist_equipped ? 'bg-[#C5A059] border-[#C5A059]' : 'border-zinc-700 bg-zinc-900 group-hover:border-zinc-500'}`}>
                          {form.hoist_equipped && <Check size={12} className="text-black" />}
                        </div>
                        <input type="checkbox" checked={form.hoist_equipped} onChange={e => updateForm('hoist_equipped', e.target.checked)} className="hidden" />
                        <span className="text-sm text-zinc-300">Verricello / Cargo Hook</span>
                      </label>
                      <label className="flex items-center gap-3 cursor-pointer group" data-testid="checkbox-ems">
                        <div className={`w-5 h-5 border flex items-center justify-center transition-colors ${form.ems_equipped ? 'bg-[#C5A059] border-[#C5A059]' : 'border-zinc-700 bg-zinc-900 group-hover:border-zinc-500'}`}>
                          {form.ems_equipped && <Check size={12} className="text-black" />}
                        </div>
                        <input type="checkbox" checked={form.ems_equipped} onChange={e => updateForm('ems_equipped', e.target.checked)} className="hidden" />
                        <span className="text-sm text-zinc-300">Configurazione EMS / HEMS</span>
                      </label>
                      <label className="flex items-center gap-3 cursor-pointer group" data-testid="checkbox-nvg">
                        <div className={`w-5 h-5 border flex items-center justify-center transition-colors ${form.nvg_compatible ? 'bg-[#C5A059] border-[#C5A059]' : 'border-zinc-700 bg-zinc-900 group-hover:border-zinc-500'}`}>
                          {form.nvg_compatible && <Check size={12} className="text-black" />}
                        </div>
                        <input type="checkbox" checked={form.nvg_compatible} onChange={e => updateForm('nvg_compatible', e.target.checked)} className="hidden" />
                        <span className="text-sm text-zinc-300">NVG Compatibile</span>
                      </label>
                    </>
                  )}
                </div>
              </div>

              {/* Description */}
              <div className="col-span-2">
                <Label className="text-zinc-400 text-xs mb-1.5 block">Descrizione</Label>
                <Textarea value={form.description} onChange={e => handleDescriptionChange(e.target.value)} placeholder="Descrivi il tuo velivolo..." className="bg-zinc-900 border-zinc-800 text-white min-h-[100px]" data-testid="input-description" />
                {descWarning && <p className="text-[10px] text-amber-400 mt-1">{descWarning}</p>}
              </div>
            </div>
          </div>
        )}

        {/* Step 2: Images */}
        {step === 2 && (
          <div className="space-y-5 animate-fade-in" data-testid="step-images">
            <h2 className="text-2xl font-medium text-white mb-6" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Immagini *</h2>
            <div className="flex items-center justify-between -mt-4 mb-4">
              <p className="text-xs text-zinc-500">Piano <span className="text-white font-medium">{chosenPlan.label}</span>: fino a <span className="text-[#C5A059]">{chosenPlan.photos}</span> foto. Consigliamo formato orizzontale per esterni ed interni.</p>
              <p className="text-xs font-mono text-zinc-400" data-testid="photo-count">{uploadedPaths.length} / {chosenPlan.photos}</p>
            </div>
            {validationErrors.length > 0 && (
              <div className="flex items-start gap-3 p-4 bg-red-500/10 border border-red-500/30" data-testid="validation-errors-images">
                <AlertTriangle size={18} className="text-red-400 shrink-0 mt-0.5" />
                <p className="text-sm text-red-400">{validationErrors[0]}</p>
              </div>
            )}
            <div className="border-2 border-dashed border-zinc-700 p-8 text-center hover:border-[#C5A059] transition-colors">
              <input type="file" multiple accept="image/*" onChange={e => handleImageUpload(Array.from(e.target.files))} className="hidden" id="image-upload" data-testid="image-upload-input" />
              <label htmlFor="image-upload" className="cursor-pointer">
                {uploadingImages ? (
                  <Loader2 size={24} className="animate-spin mx-auto text-[#C5A059] mb-3" />
                ) : (
                  <Upload size={24} className="mx-auto text-zinc-600 mb-3" />
                )}
                <p className="text-sm text-zinc-400">Clicca per caricare le immagini</p>
                <p className="text-xs text-zinc-600 mt-1">JPG, PNG, WebP fino a 10MB · max {chosenPlan.photos} foto</p>
              </label>
            </div>
            {imagePreviews.length > 0 && (
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                {imagePreviews.map((url, i) => (
                  <div
                    key={`img-${i}`}
                    className={`relative aspect-[4/3] bg-zinc-900 overflow-hidden border transition-colors ${i === 0 ? 'border-[#C5A059]/50 ring-1 ring-[#C5A059]/20' : 'border-zinc-800'}`}
                    draggable
                    onDragStart={e => handleImageDragStart(e, i)}
                    onDragOver={e => e.preventDefault()}
                    onDrop={e => handleImageDrop(e, i)}
                    data-testid={`image-slot-${i}`}
                  >
                    <img src={url} alt="" className="w-full h-full object-cover" />
                    {i === 0 && <span className="absolute top-2 left-2 bg-[#C5A059] text-black text-[9px] font-bold px-2 py-0.5">COPERTINA</span>}
                    <div className="absolute top-2 right-2 flex gap-1">
                      <button onClick={() => removeImage(i)} className="w-6 h-6 bg-zinc-950/80 flex items-center justify-center text-white hover:bg-red-500/80 transition-colors" data-testid={`remove-image-${i}`}>
                        <X size={12} />
                      </button>
                    </div>
                    <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
                      {i > 0 && (
                        <button onClick={() => moveImage(i, i - 1)} className="w-6 h-6 bg-zinc-950/80 flex items-center justify-center text-white hover:bg-zinc-700 transition-colors" data-testid={`move-left-${i}`}>
                          <ChevronLeft size={12} />
                        </button>
                      )}
                      <span className="w-6 h-6 bg-zinc-950/80 flex items-center justify-center text-zinc-400 cursor-grab active:cursor-grabbing"><GripVertical size={12} /></span>
                      {i < imagePreviews.length - 1 && (
                        <button onClick={() => moveImage(i, i + 1)} className="w-6 h-6 bg-zinc-950/80 flex items-center justify-center text-white hover:bg-zinc-700 transition-colors" data-testid={`move-right-${i}`}>
                          <ChevronRight size={12} />
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Step 3: Review */}
        {step === 3 && (
          <div className="space-y-6 animate-fade-in" data-testid="step-review">
            <h2 className="text-2xl font-medium text-white mb-6" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Riepilogo e Pubblicazione</h2>
            {/* Plan summary */}
            <div className="bg-[#C5A059]/[0.06] border border-[#C5A059]/40 p-4 flex items-center justify-between">
              <div>
                <div className="text-[10px] font-mono uppercase tracking-widest text-[#C5A059] mb-1">Piano selezionato</div>
                <div className="text-white font-medium" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>{chosenPlan.label} · {chosenPlan.priceLabel}</div>
                <div className="text-[11px] text-zinc-500 mt-0.5">{chosenPlan.duration} · fino a {chosenPlan.photos} foto</div>
              </div>
              <button onClick={() => setPlanConfirmed(false)} className="text-xs text-[#C5A059] hover:underline">Cambia</button>
            </div>
            <div className="bg-zinc-900 border border-zinc-800 p-6 space-y-3">
              {autoTitle && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Titolo</span><span className="text-white text-sm font-medium">{autoTitle}</span></div>}
              <div className="flex justify-between"><span className="text-zinc-500 text-sm">Categoria</span><span className="text-white text-sm">{CATEGORIES.find(c => c.slug === form.category)?.name}</span></div>
              <div className="flex justify-between"><span className="text-zinc-500 text-sm">Prezzo</span><span className="text-[#C5A059] text-sm font-mono">{form.price ? `${Number(form.price).toLocaleString('it-IT')} EUR` : 'Su richiesta'}</span></div>
              <div className="flex justify-between"><span className="text-zinc-500 text-sm">Anno</span><span className="text-white text-sm font-mono">{form.year}</span></div>
              <div className="flex justify-between"><span className="text-zinc-500 text-sm">Condizioni</span><span className="text-white text-sm">{form.condition === 'new' ? 'Nuovo' : 'Usato'}</span></div>
              {form.location_city && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Posizione</span><span className="text-white text-sm">{form.location_city}</span></div>}
              {form.airport_code && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Aeroporto</span><span className="text-white text-sm font-mono">{form.airport_code}</span></div>}
              {form.total_time && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Ore Airframe</span><span className="text-white text-sm font-mono">{form.total_time}h</span></div>}
              {form.registration && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Registrazione</span><span className="text-white text-sm font-mono">{form.registration}</span></div>}
              {form.damage_history && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Storico Danni</span><span className="text-white text-sm">{form.damage_history === 'never' ? 'Mai danneggiato' : 'Danneggiato'}</span></div>}
              {form.hangar_kept && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Caratteristiche</span><span className="text-white text-sm">Tenuto in hangar</span></div>}
              {form.num_engines && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Motori</span><span className="text-white text-sm font-mono">{form.num_engines}</span></div>}
              {form.engine_type && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Tipo Motore</span><span className="text-white text-sm">{form.engine_type}</span></div>}
              {form.engine_hours && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Ore Motore</span><span className="text-white text-sm font-mono">{form.engine_hours}h</span></div>}
              {form.engine2_hours && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Ore Motore 2</span><span className="text-white text-sm font-mono">{form.engine2_hours}h</span></div>}
              {form.engine3_hours && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Ore Motore 3</span><span className="text-white text-sm font-mono">{form.engine3_hours}h</span></div>}
              {form.engine4_hours && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Ore Motore 4</span><span className="text-white text-sm font-mono">{form.engine4_hours}h</span></div>}
              {form.propeller_type && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Elica</span><span className="text-white text-sm">{form.propeller_type}</span></div>}
              {form.tbo_remaining && <div className="flex justify-between"><span className="text-zinc-500 text-sm">TBO Rimanenti</span><span className="text-white text-sm font-mono">{form.tbo_remaining}h</span></div>}
              {form.total_cycles && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Cicli Totali</span><span className="text-white text-sm font-mono">{form.total_cycles}</span></div>}
              {form.apu_hours && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Ore APU</span><span className="text-white text-sm font-mono">{form.apu_hours}h</span></div>}
              {form.interior_config && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Interni</span><span className="text-white text-sm">{form.interior_config}</span></div>}
              {form.rotor_blades && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Pale Rotore</span><span className="text-white text-sm font-mono">{form.rotor_blades}</span></div>}
              {form.rotor_hours && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Ore Rotore</span><span className="text-white text-sm font-mono">{form.rotor_hours}h</span></div>}
              {form.tail_rotor_hours && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Ore Rotore di Coda</span><span className="text-white text-sm font-mono">{form.tail_rotor_hours}h</span></div>}
              {form.max_speed && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Velocita Max</span><span className="text-white text-sm font-mono">{form.max_speed} {form.category === 'ultraleggeri' ? 'km/h' : 'kts'}</span></div>}
              {form.range_km && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Autonomia</span><span className="text-white text-sm font-mono">{form.range_km} nm</span></div>}
              {form.mtow && <div className="flex justify-between"><span className="text-zinc-500 text-sm">MTOW</span><span className="text-white text-sm font-mono">{form.mtow} kg</span></div>}
              {form.seats && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Posti</span><span className="text-white text-sm font-mono">{form.seats}</span></div>}
              {form.ifr_equipped && <div className="flex justify-between"><span className="text-zinc-500 text-sm">IFR</span><span className="text-white text-sm">Attrezzato</span></div>}
              {form.commercial_certified && <div className="flex justify-between"><span className="text-zinc-500 text-sm">Uso Commerciale</span><span className="text-white text-sm">Certificato</span></div>}
              <div className="flex justify-between"><span className="text-zinc-500 text-sm">Immagini</span><span className="text-white text-sm">{uploadedPaths.length}</span></div>
            </div>
            {form.description && (
              <div className="bg-zinc-900 border border-zinc-800 p-6">
                <p className="text-xs text-zinc-500 mb-2">Descrizione</p>
                <p className="text-sm text-zinc-300">{form.description}</p>
              </div>
            )}
          </div>
        )}

        {/* Navigation */}
        <div className="flex justify-between mt-10">
          {step > 0 ? (
            <button onClick={() => setStep(step - 1)} className="flex items-center gap-2 px-6 py-3 border border-zinc-700 text-zinc-300 text-sm hover:border-zinc-500 transition-colors" data-testid="wizard-prev-btn">
              <ArrowLeft size={16} /> Indietro
            </button>
          ) : <div />}

          {step < STEPS.length - 1 ? (
            <button onClick={handleNext} className="flex items-center gap-2 bg-[#C5A059] text-black px-6 py-3 text-sm font-medium hover:bg-[#D4B271] transition-colors" data-testid="wizard-next-btn">
              Avanti <ArrowRight size={16} />
            </button>
          ) : (
            <button onClick={handlePublish} disabled={saving} className="flex items-center gap-2 bg-[#C5A059] text-black px-8 py-3 text-sm font-medium hover:bg-[#D4B271] transition-colors disabled:opacity-50" data-testid="publish-btn">
              {saving ? <Loader2 size={16} className="animate-spin" /> : <Check size={16} />}
              {saving ? 'Pubblicazione...' : (chosenPlan.price > 0 ? `Paga ${chosenPlan.priceLabel} e Pubblica` : 'Pubblica Annuncio')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
